import axios from "axios";
import { API } from "configs/api";

export const referralsPageApi = {
  postReferralCode: (body) => axios.post(API.referrals, body),
  postReferralEmail: (body) => axios.post(API.sendReferralEmail, body),
  getReferralEmailList: (params) => axios.get(API.ownersEmailList, { token: true, params }),
};
